import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyD3F2KPZI3hsP2TmzXMyd0tilV5fNwSy6c",
    authDomain: "el-rosal-177df.firebaseapp.com",
    databaseURL: "https://el-rosal-177df-default-rtdb.firebaseio.com",
    projectId: "el-rosal-177df",
    storageBucket: "el-rosal-177df.appspot.com",
    messagingSenderId: "969055720954",
    appId: "1:969055720954:web:0925bce36431e36b100043",
    measurementId: "G-9HRQKWBCKX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export default app;
